import { Button, Stack, styled, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledCardMobile = styled(Stack, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
  border: `1px solid ${
    open ? NEW_COLORS.SEMANTICS.WARNING[400] : NEW_COLORS.GRAYSCALE[100]
  }`,
  borderRadius: '8px',
  paddingBottom: '16px',
}));

const StyledStack = styled(Stack, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
  background: open ? NEW_COLORS.SEMANTICS.WARNING[25] : NEW_COLORS.BASE.WHITE,
  borderRadius: '8px 8px 0 0',
}));

const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
  background: open ? NEW_COLORS.SECONDARY[100] : NEW_COLORS.GRAYSCALE[100],
  color: open ? NEW_COLORS.SEMANTICS.WARNING[600] : NEW_COLORS.BASE.BLACK,
  paddingLeft: '16px',
  '&:hover': {
    background: open ? NEW_COLORS.SECONDARY[100] : NEW_COLORS.GRAYSCALE[200],
  },
  '&:focus': {
    background: open ? NEW_COLORS.SECONDARY[100] : NEW_COLORS.GRAYSCALE[100],
    color: open ? NEW_COLORS.SEMANTICS.WARNING[600] : NEW_COLORS.BASE.BLACK,
  },
  '&:active': {
    background: open ? NEW_COLORS.SECONDARY[100] : NEW_COLORS.GRAYSCALE[100],
    color: open ? NEW_COLORS.SECONDARY[100] : NEW_COLORS.BASE.BLACK,
  },
}));

const StyledTypography = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '127px',
}));

export { StyledCardMobile, StyledTypography, StyledStack, StyledButton };
